/* Filtrous live stock + price + publish-state prune.
   FOR LIVE THEME 1.12 (t/244, id 180621967634) ONLY.

   WHAT THIS REPLACES (2026-09-03, Adelaide)
   -----------------------------------------
   The asset named filtrous-live-stock.js on t/244 was NOT a stock shim. It
   was a stale copy of filtrous-catalog-supplement.js - same EXTRA list, same
   IMG_OVERRIDES, no availableForSale, no currentlyNotInStock, no backorder.
   Someone pasted the supplement over the wrong asset, so live ran the
   supplement TWICE and the stock shim ZERO times. Stock badges on live came
   from the baked catalog-index.json "available" flag plus the hardcoded
   PREORDER list in filtrous-v3.js, so the site could not tell that a SKU had
   gone to zero in Shopify. MBP-21-4425 (Alliance 70% Nitric Acid) read
   "In stock" on the grid, the PDP and the card while Shopify held 0 on hand.

   Replacing it loses nothing: filtrous-catalog-supplement.js is the NEWER of
   the two copies (it carries image hashes this one lacked) and still injects
   all 14 EXTRA products. The splice is guarded - have[p.sku]||push - so the
   second injection was already a no-op. The only real effect of the duplicate
   was running image hydration twice.

   MEASURED EFFECT ON LIVE (2026-09-03, baked index stamped 2026-09-01 vs the
   Storefront API, 599 index rows against 600 live SKUs)
   -----------------------------------------------------
     badge -> Sold Out   4  MBP-21-4425, SFN-CR-1013, SSB-20-0100, SSB-20-0300
     badge -> In stock   0
     pruned from browse  1  EXK-MJ-0096 (the $420 cannabis extraction-kit
                            ghost - unpublished in Shopify, injected by the
                            supplement EXTRA list, visible on live until now)
     tile price rewrites 0  (index is current; the sweep keeps it that way)

   This is deliberately NOT the "~145 SKUs will move" change the 2026-09-01
   prune-only build warned about. That warning was written against the OLD
   collapsed predicate, available = availableForSale && !currentlyNotInStock,
   which marked every backordered item unavailable. The 2026-08-27 backorder
   split ended that: available = availableForSale alone, and the zero-on-hand
   state rides separately on p.backorder. 147 of the 600 live SKUs are in that
   backorder state and every one of them keeps available = true, so none of
   them changes on live. Only genuine availableForSale = false flips to Sold
   Out, and there are 4 of those.

   1.12-SPECIFIC BEHAVIOUR - p.backorder IS SET BUT IGNORED
   --------------------------------------------------------
   filtrous-v3.js on 1.12 contains zero references to "backorder" and 1.12 has
   no filtrous-stock-badge.js, so the "Preorder" label does not exist on live.
   p.backorder is still written here, deliberately: it costs nothing, it keeps
   this file identical in behaviour to 1.13's, and it means dropping
   filtrous-stock-badge.js in later is a one-asset change with no edit here.
   Until then the 147 backorder SKUs read "In stock" on live - which is what
   they already read today, so this is not a regression. If you want them to
   read "Preorder" on live, that is the stock-badge asset, not this file.

   LOAD ORDER IS ALREADY CORRECT ON 1.12
   -------------------------------------
   sections/filtrous-v3-app.liquid on t/244 loads, in order:
   filtrous-catalog-supplement.js, filtrous-live-stock.js, filtrous-v3.js.
   Each patches window.fetch around the previous, so this file's wrapper runs
   first and delegates to the supplement's - meaning the EXTRA products are
   already spliced in when the merge runs, and are themselves subject to it.
   That is why EXK-MJ-0096 gets pruned rather than surviving as an EXTRA. No
   liquid edit is needed; the loader line already exists.

   PRICE IS IN THE SWEEP
   ---------------------
   p.price is overwritten from the Storefront API, so grid tiles can no longer
   drift from Shopify and refresh-catalog-index.mjs stops being part of the
   price workflow. Drift measured 0 today, so nothing visibly changes now; the
   point is that it stays 0 without a paste. filtrous-b2b-price.js repaints
   per-customer pricing from the ctxprice endpoint after this runs and is
   unaffected.

   GUARDS (unchanged from 1.13) - this deletes rows, so it fails safe:
     1. fetchLive returns null unless pagination ran to completion.
     2. a live map smaller than MIN_LIVE (100) is treated as a failed sweep.
     3. a prune over MAX_DROP_RATIO (25%) of the index is refused outright.
   Any guard tripping falls back to annotate-only: stock and price are still
   applied, only the deletion is withheld. Same on a missing token or a
   network failure. Today's prune ratio is 0.2%.

   TO REVERT: paste the contents of filtrous-catalog-supplement.js back over
   this asset. That restores the exact broken-but-harmless state described at
   the top. A copy is in this kit as REVERT-filtrous-live-stock.js.

   Body below is byte-identical to assets/filtrous-live-stock.js on theme 1.13
   (id 180658176274). Only this header differs. */
(function () {
  "use strict";
  var CACHE_KEY = "fv3-live-stock-v4",
    TTL_MS = 3e5,
    API = "/api/2025-01/graphql.json",
    MIN_LIVE = 100,
    MAX_DROP_RATIO = 0.25,
    QUERY = "query($after:String){products(first:250,after:$after){pageInfo{hasNextPage endCursor}nodes{variants(first:5){nodes{sku availableForSale currentlyNotInStock price{amount}}}}}}";
  function token() { try { var el = document.getElementById("shopify-features"); return el && (JSON.parse(el.textContent) || {}).accessToken || null } catch (e) { return null } }
  function cached() { try { var obj = JSON.parse(sessionStorage.getItem(CACHE_KEY)); return obj && obj.map && Date.now() - obj.ts <= TTL_MS ? obj.map : null } catch (e) { return null } }
  function store(map) { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), map: map })) } catch (e) {} }
  function money(v) { var n = Number(v); return isFinite(n) ? n.toFixed(2) : null }
  function fetchLive(rawFetch) {
    var tok = token();
    if (!tok) return Promise.resolve(null);
    var map = {};
    function page(after, hops) {
      return rawFetch(API, { method: "POST", headers: { "Content-Type": "application/json", "X-Shopify-Storefront-Access-Token": tok }, body: JSON.stringify({ query: QUERY, variables: { after: after } }) }).then(function (r) { return r.ok ? r.json() : null }).then(function (j) {
        var prods = j && j.data && j.data.products;
        if (!prods) return null;
        prods.nodes.forEach(function (p) {
          p.variants.nodes.forEach(function (v) {
            /* a = orderable at all; b = orderable but nothing on hand (backorder); p = live price */
            v.sku && (map[String(v.sku).toUpperCase()] = { a: !!v.availableForSale, b: !!(v.availableForSale && v.currentlyNotInStock), p: v.price && money(v.price.amount) })
          })
        });
        /* Absence is only meaningful over a COMPLETE sweep. Running out of hops
           mid-catalog returns null rather than a partial map. */
        return prods.pageInfo.hasNextPage ? (hops < 12 ? page(prods.pageInfo.endCursor, hops + 1) : null) : map
      })
    }
    return page(null, 0).catch(function () { return null })
  }
  /* maps.byFamily in filtrous-v3.js is products.filter(p => p.families.indexOf(h) >= 0),
     so the nav counts have to be recomputed the same way or they drift past the
     rows actually rendered. Leaves that empty out stop being linkable. */
  function recount(data) {
    var byFam = {};
    data.products.forEach(function (p) {
      p && p.families && p.families.forEach(function (h) { byFam[h] = (byFam[h] || 0) + 1 })
    });
    (data.departments || []).forEach(function (d) {
      (d.categories || []).forEach(function (c) {
        c.leaves = (c.leaves || []).filter(function (lf) { return (lf.count = byFam[lf.handle] || 0) > 0 })
      });
      d.categories = (d.categories || []).filter(function (c) { return c.leaves.length })
    });
    data.departments = (data.departments || []).filter(function (d) { return d.categories.length });
    typeof data.catalog_sku_count == "number" && (data.catalog_sku_count = data.products.length);
    typeof data.reachable_sku_count == "number" && (data.reachable_sku_count = data.products.length)
  }
  var orig = window.fetch;
  if (orig) {
    var boundOrig = orig.bind(window);
    window.fetch = function (input) {
      var url = typeof input == "string" ? input : input && input.url || "";
      if (String(url).indexOf("catalog-index") === -1) return orig.apply(this, arguments);
      var indexP = orig.apply(this, arguments),
        hit = cached(),
        liveP = hit ? Promise.resolve(hit) : fetchLive(boundOrig).then(function (m) { return m && store(m), m });
      return Promise.all([indexP, liveP]).then(function (rr) {
        var res = rr[0], live = rr[1];
        return !res || !res.ok || !live ? res : res.clone().json().then(function (data) {
          if (!data || !data.products || !data.products.length) return res;
          var total = data.products.length,
            trusted = Object.keys(live).length >= MIN_LIVE,
            kept = [], dropped = [], repriced = 0;
          data.products.forEach(function (p) {
            var k = p && p.sku ? String(p.sku).toUpperCase() : "";
            if (k && k in live) {
              var L = live[k];
              p.available = L.a;
              p.backorder = L.b;
              if (L.p != null && String(p.price) !== L.p) { p.price = L.p; repriced++ }
              kept.push(p)
            }
            else if (!k) kept.push(p); /* no sku to check against; leave it alone */
            else dropped.push(k)
          });
          /* A sweep that would gut the catalog is a broken sweep, not 400 retirements. */
          if (trusted && dropped.length && dropped.length <= total * MAX_DROP_RATIO) {
            data.products = kept;
            recount(data);
            window.console && console.info && console.info("[fv3] dropped " + dropped.length + " SKU(s) not published to the Online Store: " + dropped.join(", "))
          } else if (dropped.length) {
            window.console && console.warn && console.warn("[fv3] live sweep not trusted (" + Object.keys(live).length + " live, " + dropped.length + "/" + total + " would drop); flags and prices applied, nothing pruned")
          }
          repriced && window.console && console.info && console.info("[fv3] repriced " + repriced + " tile(s) from the Storefront API");
          return new Response(JSON.stringify(data), { status: res.status, statusText: res.statusText, headers: { "Content-Type": "application/json" } })
        }).catch(function () { return res })
      })
    }
  }
})();
